import { apiClient } from '@api';
import { ensureFeatureFlagsFetched } from '@lib/firebase';
import { FraudTracking, PatientAddress, PatientCreditCard } from '@types';
import { Adyen, type AdyenEncryptedMetadata } from '@quickmd-llc/design-system';
import { useApplicationStore } from '@data';

interface CreateCreditCardInput {
  address: PatientAddress;
  isDefault: boolean;
  adyenEncryptedMetadata: AdyenEncryptedMetadata;
}

export async function createCreditCard(
  params: CreateCreditCardInput,
): Promise<PatientCreditCard> {
  const { adyenEncryptedMetadata, address, isDefault } = params;

  const body = {
    ...adyenEncryptedMetadata,
    address,
    isDefault,
  };

  const { data } = await apiClient.post<PatientCreditCard>(
    `/api/v1/payments/creditcards${Adyen.getAdyenQueryString(true)}`,
    body,
  );

  return data;
}

export async function fetchCreditCards(): Promise<PatientCreditCard[]> {
  await ensureFeatureFlagsFetched();
  const {
    flags,
    patient: { patientProfile },
  } = useApplicationStore.getState();

  const adyenFlagObject = flags.adyen;

  const patientCreateDateTimeUtc = patientProfile?.createDateTimeUtc;
  const lastName = patientProfile?.lastName;
  const patientId = patientProfile?.patientId;
  const { adyenIsEnabled } = Adyen.getAdyenIsEnabled({
    adyenFlagObject,
    patientCreateDateTimeUtc,
    lastName,
    patientId,
  });
  const { data } = await apiClient.get<PatientCreditCard[]>(
    `/api/v1/payments/creditcards${Adyen.getAdyenQueryString(adyenIsEnabled)}`,
  );

  return data;
}

export async function fetchFraudTracking(): Promise<FraudTracking> {
  const { data } = await apiClient.get<FraudTracking>(
    '/api/v1/payments/fraudtracking',
  );

  return data;
}
